import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="members"
export default class extends Controller {
  connect() {
  }

  clearTooltips() {
    $('[data-bs-toggle="tooltip"]').each(function(){
      $(this).tooltip('hide')
    })
  }

  getMembershipId(e) {
    var item = e.currentTarget
    const selectedOption = item.options[item.selectedIndex]
    const membershipId = selectedOption.dataset.membership

    // Set the hidden field value
    const hiddenField = document.querySelector('input[name="handshake[met_with_membership_id]"]')
    if (hiddenField && membershipId) {
      hiddenField.value = membershipId
    }
  }

  /*
   * Searches for members across all chapters and populates the "other users" dropdown.
   * Called when the admin clicks the search button next to the cross-chapter member input.
   *
   * We look up the input field by traversing to the closest parent div and finding its
   * input — this keeps the button and input loosely coupled without needing hard-coded IDs.
   * The item.dataset.field attribute on the button tells us which dropdown to populate
   * (e.g., "giving" or "receiving"), allowing this same method to serve both sides of
   * the referral/handshake form. Each <option> stores the membership_id as a data attribute
   * so getMembershipId() can extract it when the user selects a person.
   */
  searchUser(e) {
    e.preventDefault()
    var item = e.currentTarget
    var elem = item.closest('div')?.querySelector('input')

    if(elem.value.length > 0) {
      $.ajax({
        type: "GET",
        url: "/members/find_members",
        data: {
          name: elem.value
        },
        success: function(data) {
          if(data.status == 200){

            var option_list = ""
            const jsonArray = JSON.parse(data.users);
            if(jsonArray.length > 0) {

              // Accessing elements in the array
              $.each(jsonArray, function(index, object) {
                var name = object.last_name + ', ' + object.first_name + ' (' + object.company_name + ') -- ' + object.chapter_city + ', ' + object.chapter_state + ' | ' + object.chapter_nickname + ' - ' + object.chapter_meeting_day_time;
                option_list += '<option value="' + object.id + '" data-membership="' + object.membership_id + '">' + name + '</option>'
              });

              document.getElementById(item.dataset.field + "_other_users").innerHTML = option_list
            } else {
              alert("No users found")
              document.getElementById(item.dataset.field + "_other_users").innerHTML = ""
            }
          }
        }
      })
    }
  }


  /*
   * Shows the correct sub-form section based on which option the user selected in the
   * "giving" or "receiving" radio/select toggle. Each option has a corresponding holder
   * div (e.g., "giving_myself_holder", "giving_other_users_holder") that wraps its inputs.
   *
   * First we hide ALL possible holder divs for the relevant side (giving or receiving),
   * then reveal only the one matching the selected value. We check for element existence
   * with getElementById before calling classList to avoid errors when some sections are
   * conditionally rendered by the server (e.g., "giving_my_users" is only rendered if
   * the current user has sub-users in their company). The final line uses item.value to
   * build the target ID dynamically, so a single method handles both "giving" and "receiving".
   */
  toggleUsers(e){
    var item = e.currentTarget

    if(item.id == "giving_display_users") {
      if(document.getElementById('giving_myself_holder')) { document.getElementById('giving_myself_holder').classList.add('hidden') }
      if(document.getElementById('giving_my_users_holder')) { document.getElementById('giving_my_users_holder').classList.add('hidden') }
      if(document.getElementById('giving_other_users_holder')) { document.getElementById('giving_other_users_holder').classList.add('hidden') }
      if(document.getElementById('giving_new_user_holder')) { document.getElementById('giving_new_user_holder').classList.add('hidden') }
    }

    if(item.id == "receiving_display_users") {
      if(document.getElementById('receiving_myself_holder')) { document.getElementById('receiving_myself_holder').classList.add('hidden') }
      if(document.getElementById('receiving_my_users_holder')) { document.getElementById('receiving_my_users_holder').classList.add('hidden') }
      if(document.getElementById('receiving_other_users_holder')) { document.getElementById('receiving_other_users_holder').classList.add('hidden') }
      if(document.getElementById('receiving_new_user_holder')) { document.getElementById('receiving_new_user_holder').classList.add('hidden') }
    }

    document.getElementById(item.value + '_holder').classList.remove('hidden')
  }

}
